import axios from 'axios';
import GlobalConfigs from "../configs/GlobalConfigs";
import * as Apis from '../apis/Apis';


export function addHoliday(title, start_date, end_date) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        title,
        start_date,
        end_date
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.ADD_HOLIDAY_DATA,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateHoliday(holiday_id, title, start_date, end_date, status) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        holiday_id,
        title,
        start_date,
        end_date,
        status
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDARE_HOLIDAY_DATA,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function getHolidayList(title, page_no, per_page) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        title,
        page_no,
        per_page
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_HOLIDAY_LIST,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateHolidayStatus(holiday_id, status) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        holiday_id,
        status
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_HOLIDAY_STATUS_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });
}

export function removeHolidays(holiday_id) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        holiday_id,
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.REMOVE_HOLIDAY_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function getLeaveType() {
    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_LEAVE_TYPE_LIST_API,
        method: "GET",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
    });
}

export function getAppliedLeaveList(page_no, per_page) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;
    let system_admin = JSON.parse(getData).system_admin;
    const postData = {
        company_id,
        page_no,
        per_page
    };
    const url = GlobalConfigs.API_URL +
        (system_admin ? Apis.GET_EMPLOYEE_APPLIED_LEAVE_LIST_API : Apis.GET_APPLIED_LEAVE_LIST_API);
    return axios({
        url: url,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function AddAppliedLeave(leave_type, start_date, end_date, description) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        leave_type,
        start_date,
        end_date,
        description
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.ADD_APPLIED_LEAVE_DATA,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateAppliedLeave(leave_id, leave_type, start_date, end_date, description) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        leave_id,
        leave_type,
        start_date,
        end_date,
        description
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_APPLIED_LEAVE_DATA,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function removeLeave(leave_id) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        leave_id,
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.REMOVE_LEAVE_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateLeaveStatus(leave_id, status) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        leave_id,
        status
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_LEAVE_STATUS_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });
}

export function getOwnLeaveCalenderList(user_id, leave_type_id) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        user_id,
        leave_type_id
    };

    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_OWN_LEAVE_CALENDAR_LIST_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });
}

export function getOwnReportLeaveList(user_id, filter_type, start_date, end_date, leave_type) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        user_id,
        filter_type,
        start_date,
        end_date,
        leave_type
    };

    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_REPORT_PERSONAL_DETAILS_LIST_API,//GET_OWN_LEAVE_REPORT_LIST_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });
}

export function AddReportPersonalDetails(leave_type, leave_date, leave_hours) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        leave_type,
        leave_date,
        leave_hours
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.ADD_REPORT_PERSONAL_DETAILS,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateReportLeaveList(user_id, personal_details) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    let company_id = JSON.parse(getData).company_id;

    const postData = {
        company_id,
        user_id,
        personal_details
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_REPORT_PERSONAL_DETAILS_LIST_API,//GET_OWN_LEAVE_REPORT_LIST_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });
}
